<template>
  <div style="margin-top: -10px;">
    <el-tabs v-model="activeName" class="tabs">
      <el-tab-pane label="协议列表" name="todo">
        <keep-alive>
        <ProtocolManageTable
          v-if="activeName == 'todo'"
          :active="activeName"
        ></ProtocolManageTable>
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="退/补款协议" name="rollback">
        <keep-alive>
        <RefundProtocolTable
          v-if="activeName == 'rollback'"
          :active="activeName"
        ></RefundProtocolTable>
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ProtocolManageTable from "./ProtocolManageTable";
import RefundProtocolTable from "../refund/RefundProtocolTable";

export default {
  components: {
    ProtocolManageTable,
    RefundProtocolTable,
  },
  data() {
    return {
      activeName: "todo",
    };
  },
};
</script>

<style lang="scss" scoped>
@import "src/common/common";
</style>



// WEBPACK FOOTER //
// src/pages/protocol/manage/ProtocolManageTab.vue